<template>
  <div class="MainVisual__back_underlayer">
    <div class="MainVisual">
      <div class="MainVisual__area_intro">
        <h1 class="MainVisual__area_intro_head">
          お友達紹介キャンペーン
        </h1>
        <div class="MainVisual__intro_main_area">
          <div class="Head__frame__wrapper">
            <div class="Head__frame Head__frame_intro_main Head__frame--lg Head__frame--pt01">
              <div class="Head__frame_intro_main_tx_area">
                <span class="_dsp-none">お友達にMELONでのマインドフルな体験をプレゼントしませんか？</span>
              </div>
            </div>
          </div>
          <div class="MainVisual__intro_main_area_img" />
        </div>
        <div class="MainVisual__intro_bottom">
          <div class="MainVisual__intro_bottom_l">
            <div class="MainVisual__intro_bottom_frame" />
            <div class="MainVisual__intro_bottom_tx">
              お友達も、紹介したあなたも
            </div>
          </div>
          <div class="MainVisual__intro_bottom_r">
            <span class="_dsp-none">利用料が1ヶ月無料！</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IntroductionBanner'
}
</script>
